import React from "react"
import { usePathname } from "next/navigation"

interface NavItem {
  name: string
  key: string
}

interface ContextualNavbarProps {
  items: NavItem[]
  currentContext: string
  onItemClick: (itemName: string) => void
}

export default function ContextualNavbar({
  items,
  currentContext,
  onItemClick,
}: ContextualNavbarProps) {
  const pathname = usePathname()

  return (
    <nav className="flex flex-1 gap-[30px] overflow-x-scroll [scrollbar-width:none]">
      {items.map((item, index) => (
        <button
          key={item.key}
          onClick={(e) => {
            onItemClick(item.key)
            e.currentTarget.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            })
          }}
          className={`relative whitespace-nowrap py-2 text-base ${
            currentContext === item.key
              ? "text-primary after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:bg-primary " +
                (index === 0
                  ? "active-btn rounded-lg bg-secondary px-4 text-white after:hidden"
                  : "")
              : index === 0
                ? "rounded-lg bg-secondary-100 px-4 hover:bg-secondary hover:text-white"
                : "hover:text-primary hover:after:absolute hover:after:bottom-0 hover:after:left-0 hover:after:h-0.5 hover:after:w-full hover:after:bg-primary"
          }`}
        >
          {item.name}
        </button>
      ))}
    </nav>
  )
}
